import Image from '@next/image';

import { AttributeDescriptionValue, AttributeDescriptionsGroup } from 'types/AttributeDescriptionsGroup';
import Typography from '@components/atoms/Typography';
import { FormattedMessage } from 'utils/intl';

import classes from './ModelAttributeDescriptionsGroup.module.scss';
import messages from './ModelAttributeDescriptionsGroup.messages';

type Props = AttributeDescriptionsGroup<AttributeDescriptionValue> & {
  productName: string;
};

const ModelAttributeDescriptionsGroup = ({ id, productName, name, icon, values }: Props): JSX.Element => (
  <div key={id} className={classes.container}>
    <Typography variant="h2" renderAs="h3" className={classes.header}>
      <FormattedMessage {...messages.attributeGroupHeader} values={{ groupName: name, productName }} />
    </Typography>
    <div className={classes.values}>
      {values.map(({ id: valueId, header, icon: valueIcon, description }) => (
        <div key={valueId} className={classes.value}>
          <div className={classes.header}>
            {(valueIcon || icon) && (
              <Image
                objectFit="contain"
                alt={name}
                resolveConfig={{
                  preset: 'i',
                  extension: valueIcon?.extension || icon?.extension,
                  name: valueIcon?.basename || icon?.basename,
                  productName: name,
                }}
                width={28}
                height={28}
              />
            )}
            <Typography variant="h3" renderAs="h4" lineHeight="18px">
              {header}
            </Typography>
          </div>
          <Typography variant="h4" renderAs="div">
            {description}
          </Typography>
        </div>
      ))}
    </div>
  </div>
);

export default ModelAttributeDescriptionsGroup;
